<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch10"></a><a id="page_11"></a><a href="#/contents#ch10"><b>Everyday Inventions</b></a></h2>
<p class="noindent"><span>Who invented the coat hanger? Historians say Thomas Jefferson.</span></p>
<p class="noindent"><span>Hungarian László Bíró, who patented the ballpoint pen, was also a sculptor and hypnotist.</span></p>
<p class="noindent"><span>Pizza was invented in 1889 by Raffaele Esposito in Naples, Italy.</span></p>
<p class="noindent"><span>The Countess du Barry, mistress of France’s King Louis XV, invented the fishbowl.</span></p>
<p class="noindent"><span>Bette Nesmith Graham, mother of Monkee Mike Nesmith, invented Liquid Paper in the 1950s.</span></p>
<p class="noindent"><span>Jack Johnson, the first African American world heavyweight boxing champion, invented the common household wrench.</span></p>
<p class="noindent"><span>Band-Aid is the trademarked name for the 1921 invention of Earle Dickson.</span></p>
<p class="noindent"><span>William Blackstone of Indiana invented the washing machine in 1874 as a birthday gift for his wife.</span></p>
<p class="noindent"><span>Marion Donovan made the first diaper cover out of a shower curtain.</span></p>
<p class="noindent"><span>Coca-Cola, invented by Dr. John S. Pemberton in 1885, was originally sold as a “brain tonic.”</span></p>
<p class="noindent"><span>The first pencil with an attached eraser was invented in 1858 by Hymen L. Lipman of Philadelphia.</span></p>
<p class="noindent"><span>A cigar-smoking lawyer from Lima, Pennsylvania, named Joshua Pusey invented book matches in 1889.</span></p>
<p class="noindent"><span>The pop-top can was invented by Ermal Fraze of Kettering, Ohio, in 1959.</span></p>
<p class="noindent"><span>Thor Bjørklund, a Norwegian, came up with the first cheese slicer in 1925.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter10.vue?b0ef423c